export default __webpack_public_path__ + "static/media/MAI.1ccf3be7.png";